var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    enableBackground: "new 0 0 52 52",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M49.7,25.3l-8.3-9c-0.6-0.6-1.4-0.1-1.4,0.9V23H30c-0.6,0-1-0.4-1-1V12h5.9c1,0,1.5-0.9,0.9-1.4l-9-8.3 c-0.4-0.3-1-0.3-1.4,0l-9,8.3c-0.6,0.6-0.1,1.4,0.9,1.4H23v10c0,0.6-0.4,1-1,1H12v-5.9c0-1-0.9-1.5-1.4-0.9l-8.3,9 c-0.3,0.4-0.3,1,0,1.4l8.3,9c0.6,0.6,1.4,0.1,1.4-0.9V29h10c0.6,0,1,0.4,1,1v10h-5.9c-1,0-1.5,0.9-0.9,1.4l9,8.3 c0.4,0.3,1,0.3,1.4,0l9-8.3c0.6-0.6,0.1-1.4-0.9-1.4H29V30c0-0.6,0.4-1,1-1h10v5.9c0,1,0.9,1.5,1.4,0.9l8.3-9 C50.1,26.3,50.1,25.7,49.7,25.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.0eddb29f65fca2adcf2edff60b85481a.svg";
export { ForwardRef as ReactComponent };